import { useMemo, useState, type ReactNode } from 'react'
import { View, type LayoutChangeEvent, type ViewProps } from 'react-native'
import { create } from 'zustand'

import { useOnScreenKeyboardScrollFix } from '../../../hooks/useOnScreenKeyboardScrollFix/useOnScreenKeyboardScrollFix'
import { useViewportSize } from '../../../hooks/useViewportSize/useViewportSize'

type TViewPortSizeStore = {
  isUsingKeyboard: boolean
  setIsUsingKeyboard: (isUsingKeyboard: boolean) => void
}

export const useViewPortSizeStore = create<TViewPortSizeStore>((set) => ({
  isUsingKeyboard: false,
  setIsUsingKeyboard: (isUsingKeyboard) => set({ isUsingKeyboard }),
}))

export const ViewPortSizeView = ({ style, ...props }: ViewProps): ReactNode => {
  const [initialHeight, setInitialHeight] = useState(0)
  const { isUsingKeyboard } = useViewPortSizeStore()
  const viewportSize = useViewportSize()
  useOnScreenKeyboardScrollFix()

  const maxHeight = useMemo(() => {
    if (!isUsingKeyboard && initialHeight) return initialHeight
    return viewportSize?.[1]
  }, [isUsingKeyboard, initialHeight, viewportSize])

  const handleLayout = (e: LayoutChangeEvent) => {
    if (isUsingKeyboard) return
    const h = e.nativeEvent.layout.height
    setInitialHeight((prev) => (h > prev ? h : prev))
  }

  return <View {...props} onLayout={handleLayout} style={[style, { maxHeight }]} />
}
